<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div style="background-color: white">
            <br>
            <div class="row" style="padding: 10px">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">วันที่รับเงิน</label>
                        <div class="col-sm-6">
                            <date-picker
                                v-model="form.date"
                                class="w-100"
                                :format="changeFormat"
                                :lang="lang"
                                :disabled="disable_date"
                                placeholder="วันที่เริ่มต้น">
                            </date-picker>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">รหัสเซลล์</label>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.sale"
                                :options="optionSeller"
                                :customLabel="saleWithLabel"
                                :show-labels="false"
                                @input="getCustomerFromSale(form.sale)"
                                placeholder="กรุณาเลือกเซลล์"
                                track-by="sale_id">
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">รหัสลูกค้า</label>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.customer"
                                placeholder="เลือกลูกค้า"
                                :multiple="true"
                                :options="customers"
                                :show-labels="false"
                                @input="getBillingPayoff"
                                :customLabel="customerWithLabel"
                                track-by="id">
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group row" v-if="form.sale && form.customer">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">ใบวางบิล</label>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.billing"
                                placeholder="เลือกใบวงบิล"
                                :multiple="true"
                                :options="billings"
                                :show-labels="false"
                                @input="getInvoicePayoff"
                                label="no"
                                track-by="id">
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row" v-if="form.payoff_status_id || payoff_status_id">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">เลขที่ RV</label>
                        <div class="col-sm-6">
                            <masked-input v-model="form.payoff_number"
                                          mask="RV111111111"
                                          placeholder="เลข RV"
                                          class="form-control"
                                          type="text"/>
                        </div>
                    </div>
                    <div class="form-group row" v-if="form.payoff_number_history">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">ประวัติเลข RV เดิม</label>
                        <div class="col-sm-6">
                            <textarea v-model="form.payoff_number_history"
                                      placeholder="เลข RV เดิม"
                                      class="form-control"
                                      type="text"
                                      disabled/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">ยอดรับ</label>
                        <div class="col-sm-6">
                            <input class="form-control" type="number"
                                   v-model="calculateAmountPaid" disabled/>
                        </div>
                    </div>
                    <div class="form-group row" v-if="form.transactions.length > 0">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">ประเภทการชำระเงิน</label>
                        <div class="col-sm-6">
                            <template v-for="transaction in form.transactions">
                                <input type="checkbox" v-model="transaction.transaction_type_id"
                                       checked disabled/>
                                <span v-if="transaction.transaction_type">
                                    {{ transaction.transaction_type.name }} : {{ transaction.amount | currency }} บาท
                                    (วันที่ {{ transaction.date ? transaction.date : form.date | moment("DD/MM/YYYY") }})
                                </span>
                                <br>
                            </template>
                            <template v-if="form.fee_amount > 0">
                                <span>ค่าธรรมเนียม : {{ form.fee_amount | currency }} บาท</span>
                            </template>
                            <template v-if="form.overpay > 0">
                                <span>จ่ายเงินเกิน : {{ form.overpay | currency }} บาท</span>
                            </template>
                            <template v-if="form.arrears > 0">
                                <span>จ่ายเงินขาด : {{ form.arrears | currency }} บาท</span>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div style="color: blue; padding-left: 20px">**ตัดชำระได้ก็ต่อเมื่อ มีจำนวนเงินส่งมากับ TN หากไม่มีจำนวนเงิน
                กรุณากดบันทึกรับที่หน้าบิลขาย เมนูคนขับส่งสินค้าแล้ว
            </div>
            <div style="color: red; padding-left: 20px">**TN สีแดง คือ TN มีการบันทึกรับมาจากหน้าบิลขาย</div>
            <div style="margin:0 30px" v-if="invoices.length > 0" v-for="invoice in invoices">
                <h4 style="background-color: #BDBDBD; color:black;
                padding: 5px ;text-align: center">ชื่อลูกค้า :
                    {{ invoice[0].invoice ? invoice[0].invoice.customer.name : '-' }}
                </h4>
                <div class="table-responsive">
                    <table class="table" style="text-align: center">
                        <tr>
                            <th scope="col">บิล</th>
                            <th scope="col">วันที่บิล</th>
                            <th scope="col">เลขที่ใบวางบิล</th>
                            <th scope="col">ยอดเต็ม</th>
                            <th scope="col">ส่วนลด % ใบวางบิล (บาท)</th>
                            <th scope="col">คงค้าง</th>
                            <th scope="col">#รับใบบิล(TN)</th>
                            <th scope="col">#รับเงิน</th>
                            <th scope="col" width="350">ยอดชำระ</th>
                        </tr>
                        <template v-for="(data,index) in invoice">
                            <tr :class="{ 'text-danger' : data.from_invoice_status }">
                                <td>
                                    <template v-if="data.invoice">
                                        {{ data.invoice ? data.invoice.invoice_id : '-' }}
                                    </template>
                                </td>
                                <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                                <td>
                                    <template v-if="data.invoice && data.invoice.billing_id">
                                        {{ data.billing_id }}
                                    </template>
                                    <template v-else>-</template>
                                </td>
                                <td>{{ data.invoice ? data.invoice.total : 0 | currency }}</td>
                                <td>{{ data.discount | currency }}</td>
                                <td>{{ data.remaining_payoff - data.amount | currency }}</td>
                                <td><input type="checkbox" v-model="data.receive_status"/></td>
                                <td><input type="checkbox" v-model="data.receive_amount_status"/></td>
                                <td align="center">
                                    <input type="number"
                                           class="form-control col-sm-7"
                                           v-model="data.amount"/>
                                </td>
                            </tr>
                        </template>
                    </table>
                </div>
            </div>
            <div class="col text-right">
                <div>รวมทั้งหมด : {{ calculateTotal | currency }}</div>
                <div>คงเหลือ : {{ calculateBalance | currency }}</div>
            </div>
            <br/>
            <template v-if="form.payoff_status_id !== 1">
                <div class="col text-center" style="margin-left: 30px">
                    <button type="button" class="btn btn-success"
                            :disabled="validateSubmit || checkOverPay"
                            @click="goToInvoicePayoffTransaction">
                        <icon name="save"></icon>
                        บันทึก
                    </button>
                    &nbsp;&nbsp;
                    <button type="button" class="btn btn-outline-secondary" @click="goToPayoffList">
                        <icon name="times"></icon>
                        ยกเลิก
                    </button>
                </div>
            </template>
            <template v-else>
                <div class="col text-right">
                    <button type="button" class="btn btn-success"
                            @click="updateRv">
                        <icon name="pencil-alt"></icon>
                        แก้ไขเลข RV
                    </button>
                </div>
            </template>
            <br/>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker'
import Multiselect from "vue-multiselect";
import Loading from "../../Utility/Loading";
import MaskedInput from 'vue-masked-input'

export default {
    name: "invoice-payoff-form",
    props: {
        id: {default: null},
        payoff_status_id: {default: null},
        invoice_id: {default: null},
    },
    components: {
        Loading,
        Multiselect,
        DatePicker,
        MaskedInput,
    },
    data() {
        return {
            validate_rv_number: null,
            disable_date: false,
            receive_amount: 0,
            checkbox_invoice: [],
            customers: [],
            balance: 0,
            items: [
                {
                    text: "รายการตัดชำระ",
                    to: {name: "payoff-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.$store.dispatch("Seller/get");
        //set balance
        if (!this.form.id) {
            if (!this.invoice_id) {
                this.$store.dispatch("InvoicePayoff/clearDataForm").then(() => {
                    this.checkbox_invoice = [];
                    this.$store.dispatch("InvoicePayoff/clearTransaction");
                })
            } else {
                this.getBillingPayoff();
                this.disable_date = true;
            }
        }
        if (this.id) {
            this.disable_date = true;
        }
        if (!this.form.payoff_number) {
            this.generateRV();
        }
    },
    computed: {
        ...mapState({
            optionSeller: state => {
                return state.Seller.data;
            },
            form: state => {
                return state.InvoicePayoff.form
            },
            billings: state => {
                return state.InvoicePayoff.billings;
            },
            invoices: state => {
                return state.InvoicePayoff.form.details;
            },
            user: state => {
                return state.Auth.user;
            },
        }),
        calculateTotal() {
            let sum = 0;
            if (this.invoices && this.invoices.length > 0) {
                this.invoices.forEach(invoice => {
                    invoice.forEach(item => {
                        sum = parseFloat(sum) + parseFloat(item.remaining_payoff);
                    })
                });
            }
            return this.form.total = parseFloat(sum).toFixed(2);
        },
        calculateBalance() {
            let balance = 0;
            let price = 0;
            this.form.balance = this.form.details.forEach(details => {
                details.forEach(data => {
                    price = data.amount;
                    if (data.receive_amount_status) {
                        if (!data.amount) {
                            price = 0
                        }
                        balance += (parseFloat(data.remaining_payoff) - parseFloat(price));
                    }
                })
            });
            // if(balance < 0){
            //     this.validateSubmit = true;
            //     // balance = 0;
            // }else{
            //     this.validateSubmit = false;
            // }
            return this.form.balance = parseFloat(balance).toFixed(2);
        },
        calculateAmountPaid() {
            let amount = 0;
            let price = 0;
            this.form.balance = this.form.details.forEach(details => {
                details.forEach(data => {
                    price = data.amount;
                    if (data.receive_amount_status) {
                        if (!data.amount) {
                            price = 0
                        }
                        amount += parseFloat(price);
                    }
                })
            });
            return this.form.amount = parseFloat(amount).toFixed(2);
        },
        validateSubmit() {
            if (this.form.payoff_status_id) { //มีการตัดชำระ เช็คว่ามีเลข RV หรือยัง
                if (this.form.payoff_number) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        checkOverPay() {
            if (this.form.balance < 0) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        saleWithLabel(option) {
            return `${option.sale_id} - ${option.name}`
        },
        customerWithLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        getCustomerFromSale(sale) {
            //clear details invoice
            this.form.details = [];
            this.form.customer = [];
            this.customers = [];
            if (sale) {
                let sale_id = sale.id;
                this.$store.dispatch("InvoicePayoff/getCustomerFromSale", sale_id).then(res => {
                    this.customers = res;
                });
            }
        },
        //ดึงรายการคงค้างชำระจาก invoice
        getInvoicePayoff() {
            //console.log("from invoice payoff");
            if (this.form.customer.length > 0) {
                let customer_id = [];
                let billing_id = [];
                let invoice_id = ""; //มาจาก บันทึกรับ หน้าบิลขาย
                if (this.invoice_id) {
                    invoice_id = this.invoice_id;
                }
                if (this.form.customer.length > 0) {
                    this.form.customer.forEach(data => {
                        customer_id.push(data.id)
                    });
                    if (this.form.billing.length > 0) {
                        this.form.billing.forEach(billing => {
                            billing_id.push(billing.id)
                        });
                    }
                    let data = {
                        customer_id: customer_id.toString(),
                        billing_id: billing_id.toString(),
                        invoice_id: invoice_id
                    };
                    //console.log(data);
                    this.$store.dispatch("InvoicePayoff/getInvoiceFormCustomer", data)
                } else {
                    this.form.details = [];
                }
                this.getBillingPayoff();
            }
        },
        //ดึงรายการคงค้างชำระจาก invoice จาก เลขที่ใบบิล
        getBillingPayoff() {
            let customer_id = [];
            let billing_id = [];
            let invoice_id = ""; //มาจาก บันทึกรับ หน้าบิลขาย
            if (this.invoice_id) {
                invoice_id = this.invoice_id;
            }
            if (this.form.sale && this.form.customer.length > 0) {
                this.form.customer.forEach(customer => {
                    customer_id.push(customer.id);
                });
                if (this.form.billing.length > 0) {
                    this.form.billing.forEach(billing => {
                        billing_id.push(billing.id)
                    });
                }
                let data = {
                    sale_id: this.form.sale.id,
                    customer_id: customer_id.toString()
                };
                let info = {
                    customer_id: customer_id.toString(),
                    billing_id: billing_id.toString(),
                    invoice_id: invoice_id
                };
                this.$store.dispatch("InvoicePayoff/getInvoiceFormCustomer", info).then(() => {
                    this.$store.dispatch("InvoicePayoff/getBillingPayoff", data)
                });
            } else {
                this.form.details = [];
            }
        },
        goToInvoicePayoffTransaction() {
            if (!this.form.date) {
                alert("กรุณาเลือกวันที่");
            } else if (!this.form.sale) {
                alert("กรุณาเลือกเซลล์")
            } else if (this.form.customer.length < 1) {
                alert("กรุณาเลือกลูกค้า")
            } else if (this.form.amount < 1) {
                alert("กรุณาใส่จำนวนเงินที่ได้รับมาจากลูกค้า หากไม่มีจำนวนเงิน กรุณากดบันทึกรับที่หน้าบิลขาย เมนูคนขับส่งสินค้าแล้ว")
            } else {
                this.status_loading = 1;
                this.form.balance = this.calculateBalance;
                this.form.draft_user_id = this.user.id;
                if (this.form.payoff_number) {
                    let data = {
                        rv_number: this.form.payoff_number,
                        id: this.form.id,
                    };
                    this.$store.dispatch("InvoicePayoff/validateInvoicePayoff", data).then(res => {
                        if (res) {
                            this.$router.push({
                                name: "invoice-payoff-transactions", //InvoicePayoffTransaction.vue
                                params: {payoff_status_id: this.payoff_status_id}
                            });
                        } else {
                            alert('เลข RV ซ้ำ กรุณากรอกใหม่');
                        }
                    })
                } else {
                    this.$router.push({
                        name: "invoice-payoff-transactions", //InvoicePayoffTransaction.vue
                        params: {payoff_status_id: this.payoff_status_id}
                    });
                }
            }
        },
        goToPayoffList() {
            this.$router.push({name: "payoff-list"})
            this.$store.dispatch("InvoicePayoff/clearDataForm");
            this.$store.dispatch("InvoicePayoff/clearTransaction");
        },
        generateRV() {
            if (this.payoff_status_id) {
                this.$store.dispatch('InvoicePayoff/generateRV').then(res => {
                    this.form.payoff_number = res;
                });
            }
        },
        updateRv() {
            let data = {
                id: this.form.id,
                payoff_number: this.form.payoff_number,
            }
            this.$store.dispatch("InvoicePayoff/updateRv", data).then(() => {
                this.$store.dispatch("InvoicePayoff/setInvoicePayoff", {
                    transaction_type_id: ""
                }).then(() => {
                    this.$router.push({name: "payoff-list"});
                });
            }).catch(() => {
                alert('ไม่สามารถแก้ไขเลข RV ได้');
            })
        }
    }
}

</script>

<style lang="scss" scoped>
</style>
